import { Stack } from '@mui/material';
import { Typography } from '@uy3/web-components';
import ShowValuesButton from 'components/ShowValuesButton/ShowValuesButton';
import { IBalanceType } from 'contexts/bankAccount/bankAccountContext'
import { useShowValues } from 'contexts/showValuesContext';
import { formatCurrencyInCents } from 'helpers';
import React from 'react'
import { activeTheme } from 'services/theme';

type BankAccountBalanceProps = {
    balanceData: IBalanceType;
}

const theme = activeTheme();

export const BankAccountBalance: React.FC<BankAccountBalanceProps> = (props) => {
    const { balanceData: { currentBalance, blockedBalance, available } } = props;
    const { showValues } = useShowValues();

    const blockedBalanceExist: boolean = blockedBalance !== undefined && blockedBalance !== null;

    const renderValueWithShowValue = (value: number) =>
        showValues ? formatCurrencyInCents(value ?? 0) : "---------------";

    return (
        <Stack borderRadius='8px' padding='15px 23px' border='0.5px solid #BABFD0'>
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                <Typography variant='md' fontWeight='bold'>Saldo disponível</Typography>
                <ShowValuesButton />
            </Stack>

            <Typography fontSize='30px' fontWeight='bold' color={theme.palette.primary.main}>
                {renderValueWithShowValue(available ?? 0)}
            </Typography>

            <Stack spacing={1} pt={2} borderTop='1px solid #f0eded'>
                {blockedBalanceExist && (
                    <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        <Typography variant='sm'>Valores bloqueados: </Typography>
                        <Typography variant='sm'>{blockedBalance > 0 && "-"}{renderValueWithShowValue(blockedBalance)}</Typography>
                    </Stack>
                )}

                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                    <Typography variant='sm'>Saldo total da conta: </Typography>
                    <Typography variant='sm'>{renderValueWithShowValue(currentBalance)}</Typography>
                </Stack>
            </Stack>

        </Stack>
    )
}
